<template>
    <el-row>
        <el-col :span="20" :offset="2">
            <el-row>
                <el-col :span="12">
                    <h1 align="left">Generate Notify</h1>
                </el-col>
                <el-col :span="12" align="right">
                    <el-date-picker
                        v-model="filterDate"
                        type="date"
                        style="margin-top: 12px;"
                        placeholder="Pick a day"
                        @change="filterNotify"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-table
                ref="OrderList"
                :data="notifyList"
                :header-cell-style="{
                    'background-color': 'black',
                    color: 'white'
                }"
                style="width: 100%; margin-top: 10px;"
            >
                <el-table-column label="Cus ID" width="150"
                    ><template slot-scope="scope">
                        {{ scope.row.user_code }}</template
                    ></el-table-column
                >
                <el-table-column label="Shop" width=""
                    ><template slot-scope="scope">
                        <p  v-for="item in scope.row.shops" :key="item.id">{{item.name}}</p>
                    </template
                    ></el-table-column
                >
               <el-table-column label="จำนวนเคส" width="150"
                    ><template slot-scope="scope">
                        <p  v-for="item in scope.row.shops" :key="item.id">{{item.number_of_cases}}</p>
                    </template
                    ></el-table-column
                >
                <el-table-column label="ข้อความสรุป Case" width="150"
                    ><template>
                        <a>COPY</a></template
                    ></el-table-column
                >
                <el-table-column label="ร้านไหนแจ้งแล้ว" width="200"
                    ><template slot-scope="scope">
                        <el-switch
                            style="display: block"
                            v-model="scope.row.is_notified"
                            @change="updateStatus(scope.row)"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </template
                ></el-table-column
                >
            </el-table>

            <el-col style="margin-top:10px;">
                <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
                ></el-pagination>
            </el-col>

        </el-col>
    </el-row>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'GenerateNotify',
    data () {
        return {
            notifyStatus: {
                true: 'generate',
                false: 'cancel'
            },
            notifyList: [{
                customer_id: 1
            },
            {
                customer_id: 2
            }
            ],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            filterDate: null
        }
    },
    created () {
        this.getdata()
    },
    methods: {
        filterNotify () {
            // ------ waiting P'A logic --------//
        },
        async getdata () {
            var listNotify = await fgApi.caseTracking.getListNotify('')
            this.notifyList = listNotify.data.result
        },
        async updateStatus (notifiyData) {
            let body = {
                'customer_support_id': notifiyData.current_customer_support.customer_support_id,
                'customer_id': notifiyData.customer_id,
                'date': '0001-01-01',
                'type': this.notifyStatus[notifiyData.is_notified]
            }
            let respone = await fgApi.caseTracking.updateNotify(body)
            console.log(respone)
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchOrder()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.fetchOrder()
        }
    }
}
</script>
